import { useRef, useState, type RefObject } from "react";

// The chat composer's input value and its textarea handle — the only legitimate
// local state of the shared conversation component, isolated here so the
// component stays state-free (per the webapp React rules: state lives in
// dedicated hooks, not business components).
export function useChatComposer(initial: string): {
  value: string;
  setValue: (value: string) => void;
  reset: () => void;
  // The textarea itself, for the things only the DOM node knows — the caret
  // dictation inserts at.
  ref: RefObject<HTMLTextAreaElement>;
} {
  const [value, setValue] = useState(initial);
  const ref = useRef<HTMLTextAreaElement>(null);
  return {
    value,
    setValue,
    reset: () => {
      setValue("");
    },
    ref,
  };
}
